import Vue from 'vue'
import store from '../store';
import VueRouter from 'vue-router'
import {getCookie} from "@/helperFunctions";
const Univers = () => import(/* webpackChunkName: "univers" */ "@/views/Univers")
const Oelteltet = () => import(/* webpackChunkName: "oeltetet" */ "@/views/Oelteltet")
const Tivoli = () => import(/* webpackChunkName: "tivoli" */ "@/views/Tivoli")
const Boderne = () => import(/* webpackChunkName: "boderne" */ "@/views/Boderne")
const Oversigt = () => import(/* webpackChunkName: "oversigt" */  "@/views/boderne/Oversigt");
const Kraemmer = () => import(/* webpackChunkName: "kraemmer" */  "@/views/boderne/Kraemmer");
const Produkt = () => import(/* webpackChunkName: "produkt" */  "@/views/boderne/Produkt");
const Sider = () => import(/* webpackChunkName: "sider" */  "@/views/Info");
const Login = () => import(/* webpackChunkName: "login" */  "@/views/Login");
const Entre = () => import(/* webpackChunkName: "entre" */  "@/views/login/Entre");
const KomIndenfor = () => import(/* webpackChunkName: "komindenfor" */  "@/views/login/KomIndenfor");
const Token = () => import(/* webpackChunkName: "token" */  "@/views/login/Token");
const DeFarendeSvende = () => import(/* webpackChunkName: "defarendesvende" */  "@/views/info/DeFarendeSvende");
const Historie = () => import(/* webpackChunkName: "historie" */  "@/views/info/Historie");
const Hestemarked = () => import(/* webpackChunkName: "hestemarked" */  "@/views/info/Hestemarked");
const Camping = () => import(/* webpackChunkName: "camping" */  "@/views/info/Camping");
const Markedsinfo = () => import(/* webpackChunkName: "markedsinfo" */  "@/views/info/Markedsinfo");
const Kraemmerne = () => import(/* webpackChunkName: "kraemmerne" */  "@/views/info/Kraemmerne");
const Esport = () => import(/* webpackChunkName: "esport" */  "@/views/Esport");
const Partytruck = () => import(/* webpackChunkName: "partytruck" */  "@/views/Partytruck");

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'univers',
		component: Univers
	},
	{
		path: '/login',
		component: Login,
		children: [
			{
				path: '/',
				name: 'token',
				component: Token
			},
			{
				path: 'koeb-entre',
				name: 'koeb-entre',
				component: Entre
			},
			{
				path: 'koeb-entre/success',
				name: 'koeb-entre-success',
				component: KomIndenfor
			},
		]
	},
	{
		path: '/oelteltet',
		name: 'oelteltet',
		component: Oelteltet,
		meta: {
			enableAuth: true,
		}
	},
	{
		path: '/esport',
		name: 'esport',
		component: Esport,
		meta: {
			enableAuth: true,
		}
	},
	{
		path: '/tivoli',
		name: 'tivoli',
		component: Tivoli,
		meta: {
			enableAuth: true,
		}
	},
	{
		path: '/partytruck',
		name: 'partytruck',
		component: Partytruck,
		meta: {
			enableAuth: true,
		}
	},
	{
		path: '/boderne',
		component: Boderne,
		children: [
			{
				path: '/',
				name: 'boderne',
				component: Oversigt,
				meta: {
					enableAuth: true,
				}
			},
			{
				path: 'kraemmer/:id',
				name: 'kraemmer',
				component: Kraemmer,
				meta: {
					enableAuth: true,
				}
			},
			{
				path: 'produkt/:id',
				name: 'produkt',
				component: Produkt,
				meta: {
					enableAuth: true,
				}
			}

		]
	},
	{
		path: '/info',
		component: Sider,
		children: [
			{
				path: '/info/de-farende-svende',
				name: 'de-farende-svende',
				component: DeFarendeSvende
			},
			{
				path: '/info/historie',
				name: 'historie',
				component: Historie
			},
			{
				path: '/info/heste-og-smaadyr',
				name: 'heste-og-smaadyr',
				component: Hestemarked
			},
			{
				path: '/info/camping',
				name: 'camping',
				component: Camping
			},
			{
				path: '/info/markedsinfo',
				name: 'markedsinfo',
				component: Markedsinfo
			},
			{
				path: '/info/kraemmerne',
				name: 'kraemmerne',
				component: Kraemmerne
			},
		]
	},
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	const ccCookie = getCookie('vb_ac');
	const allowedRoutes = ['univers','koeb-entre','koeb-entre-success']
	if(new Date().getTime() < 1594893600000 && allowedRoutes.indexOf(to.name) === -1 && ccCookie === undefined)
	{
		next({ name: 'univers' })
	}
	else
	{
		if(typeof to.meta !== 'undefined' && typeof to.meta.enableAuth !== 'undefined' && to.meta.enableAuth === true)
		{
			if(store.state.vorbasse.hasPerformedInitialLoad === false)
			{
				const interval = setInterval(() => {
					if(store.state.vorbasse.hasPerformedInitialLoad === true)
					{
						clearInterval(interval);
						handleRouteAuth(to,from,next)
					}
				},20);
			}
			else
			{
				handleRouteAuth(to,from,next)
			}
		}
		else
		{
			next();
		}
	}
});

function handleRouteAuth(to,from,next){
	if(store.state.vorbasse.isAuthorized === true)
	{
		next()
	}
	else
	{
		if(from.name !== "univers"){
			next({ name: 'univers' })
		}
		store.commit('ux/setGuideState', 'need-access')
		store.commit('ux/setRouteReferrerName', to.name)
	}
}


export default router
